import axios from "axios";
import { API_ROOT } from "../constants";
import { setCookie, errorResponse, vendorPath } from "../helpers";

export const GET_VENDOR_START = "GET_VENDOR_START";
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const GET_VENDOR_FAIL = "GET_VENDOR_FAIL";

export const GET_VENDOR_PRODUCTS_START = "GET_VENDOR_PRODUCTS_START";
export const GET_VENDOR_PRODUCTS_SUCCESS = "GET_VENDOR_PRODUCTS_SUCCESS";
export const GET_VENDOR_PRODUCTS_FAIL = "GET_VENDOR_PRODUCTS_FAIL";

export const GET_VENDOR_ADDONS_START = "GET_VENDOR_ADDONS_START";
export const GET_VENDOR_ADDONS_SUCCESS = "GET_VENDOR_ADDONS_SUCCESS";
export const GET_VENDOR_ADDONS_FAIL = "GET_VENDOR_ADDONS_FAIL";

export const SET_CURRENT_CATEGORY = "SET_CURRENT_CATEGORY";

export function setCurrentCategory(category) {
	return {
		type: SET_CURRENT_CATEGORY,
		category
	}
}

export function getVendor(where) {
	return function (dispatch, getState) {
		dispatch({
			type: GET_VENDOR_START,
			where
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/vendors`, {
			params: where,
			headers: token ? {
				Authorization: `Bearer ${token}`
			} : null,
		}).then(res => res.data).then(results => {
			if (!results || !results[0]) throw new Error("Vendor not found.");
			setCookie({
				key: "redirect_to",
				value: vendorPath(results[0].slug)
			});
			dispatch({
				type: GET_VENDOR_SUCCESS,
				vendor: results[0]
			});
		}).catch(error => {
			dispatch({
				type: GET_VENDOR_FAIL,
				error: errorResponse(error)
			});
		})
	}
}

export function getVendorProducts() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_VENDOR_PRODUCTS_START
		});

		// Get the current token.
		const { session: { token }, vendor: { id } } = getState();

		axios.get(`${API_ROOT}/products`, {
			params: { vendor: id },
			headers: token ? {
				Authorization: `Bearer ${token}`
			} : null,
		}).then(res => res.data).then(products => {
			dispatch({
				type: GET_VENDOR_PRODUCTS_SUCCESS,
				products
			});
		}).catch(error => {
			dispatch({
				type: GET_VENDOR_PRODUCTS_FAIL,
				error: errorResponse(error)
			});
		})
	}
}

export function getVendorAddOns() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_VENDOR_ADDONS_START
		});

		// Get the current token.
		const { session: { token }, vendor: { id } } = getState();

		axios.get(`${API_ROOT}/add-ons`, {
			params: { vendor: id },
			headers: token ? {
				Authorization: `Bearer ${token}`
			} : null,
		}).then(res => res.data).then(addOns => {
			dispatch({
				type: GET_VENDOR_ADDONS_SUCCESS,
				addOns
			});
		}).catch(error => {
			dispatch({
				type: GET_VENDOR_ADDONS_FAIL,
				error: errorResponse(error)
			});
		})
	}
}
